/** @jsxImportSource @emotion/react */

import React from "react";

import { css } from "@emotion/react";

import { ApexOptions } from "apexcharts";

import {
  ACCENT_COLOR,
  ANSWER_DUNNO_STROKE,
  ANSWER_O_STROKE,
  ANSWER_X_STROKE,
  DIVIDER_COLOR_LIGHT
} from "../../../../constants/colors";

import { apexChartBasicOptions } from "../fixtures";

import ReactApexChart from "react-apexcharts";

import { AnswerCountSchema } from "../../../../constants/firestore_schema";

import { isArray } from "lodash";

const chartWrapper = css`
  height: 245px;

  .apexcharts-tooltip .apexcharts-active {
    outline: none !important;
    color: white !important;
  }

  .apexcharts-tooltip .apexcharts-theme-light {
    border: 1px solid ${DIVIDER_COLOR_LIGHT} !important;
  }
`;

export default function AgeBarChartV2({
  age,
  stats,
  colorScale = [ANSWER_O_STROKE, ANSWER_DUNNO_STROKE, ANSWER_X_STROKE]
}: {
  age: string;
  stats: AnswerCountSchema;
  colorScale?: string[];
}) {
  if (!stats) {
    return null;
  }

  const data: ApexAxisChartSeries = [
    {
      name: "찬성",
      data: [
        {
          x: 0,
          y: stats.o
        }
      ]
    },
    {
      name: "중립",
      data: [
        {
          x: 0,
          y: stats["?"]
        }
      ]
    },
    {
      name: "반대",
      data: [
        {
          x: 0,
          y: stats.x
        }
      ]
    }
  ];

  const options: ApexOptions = {
    ...apexChartBasicOptions,
    series: data,
    states: {
      active: {
        filter: {
          type: "none"
        }
      }
    },
    chart: {
      type: "bar",
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false
      }
    },
    colors: colorScale,
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "60"
      }
    },
    dataLabels: {
      enabled: true,
      distributed: true,
      offsetY: -2,
      style: {
        fontSize: "18px",
        fontWeight: "400",
        colors: [ACCENT_COLOR],
        fontFamily: "SUIT"
      },
      formatter: val => {
        if (isArray(val) || typeof val === "string" || val < 7) {
          return "";
        }

        return val.toFixed(1);
      },
      enabledOnSeries: [0, 1, 2]
    },
    tooltip: {
      onDatasetHover: {
        highlightDataSeries: false
      },
      marker: {
        show: false
      },
      fillSeriesColor: true,
      shared: false,
      x: {
        show: false
      },
      y: {
        formatter: val => {
          return Math.abs(val) + "명";
        }
      }
    },
    yaxis: {
      show: false,
      min: 0,
      max: 100
    }
  };

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 55px;
        width: 430px;
      `}
    >
      <div
        css={css`
          font-weight: 600;
          font-size: 16px;
          white-space: nowrap;
        `}
      >
        {age}
      </div>

      <div>
        <ReactApexChart
          options={options}
          series={data}
          type="bar"
          width={390}
          height={100}
        />
      </div>
    </div>
  );
}
